import { ValidationRuleTriggers } from "./triggers";
import { InputValidationResult, InputValidationResultKind } from "../input";
import { localize } from "client_legacy/ndaw/culture";
import { isNil } from "client/Misc/utils";

export class IsPositiveRule extends ValidationRuleTriggers<number | null> {
	private readonly _alternativeMessage: string | undefined;

	constructor(alternativeMessage?: string) {
		super();
		this._alternativeMessage = alternativeMessage;
	}

	public validate(value: number | null): InputValidationResult {
		if (isNil(value) || value > 0) {
			return {
				kind: InputValidationResultKind.Valid
			};
		}

		return {
			kind: InputValidationResultKind.Invalid,
			errorMessage: this._alternativeMessage || localize("_MustBePositive")
		};
	}
}

export class HasMaxValueRule extends ValidationRuleTriggers<number | null> {
	private readonly _maxValue: number;

	constructor(maxValue: number) {
		super();
		this._maxValue = maxValue;
	}

	public validate(value: number | null): InputValidationResult {
		if (isNil(value) || value <= this._maxValue) {
			return {
				kind: InputValidationResultKind.Valid
			};
		}

		return {
			kind: InputValidationResultKind.Invalid,
			errorMessage: localize("_TheMaximumValueIsMaxValue")
				.replace("{{Amount}}", `${this._maxValue}`)
		};
	}
}

export class HasMinValueRule extends ValidationRuleTriggers<number | null> {
	private readonly _minValue: number;

	constructor(maxValue: number) {

		super();
		this._minValue = maxValue;
	}

	public validate(value: number | null): InputValidationResult {
		if (isNil(value) || value >= this._minValue) {
			return {
				kind: InputValidationResultKind.Valid
			};
		}

		return {
			kind: InputValidationResultKind.Invalid,
			errorMessage: localize("_TheMinimumValueIsMinValue")
				.replace("{{Amount}}", `${this._minValue}`)
		};
	}
}

export class IsInt32Rule extends ValidationRuleTriggers<number | null> {
	private static _minValue: number | undefined;
	private static _maxValue: number | undefined;

	public validate(value: number | null): InputValidationResult {
		const [
			minValue,
			maxValue
		] = this.getBoundaries();

		if (isNil(value)) {
			return {
				kind: InputValidationResultKind.Valid
			};
		}

		if (value >= minValue && value <= maxValue) {
			return {
				kind: InputValidationResultKind.Valid
			};
		}

		return {
			kind: InputValidationResultKind.Invalid,
			errorMessage: localize("_MustBeNumber")
		};
	}

	private getBoundaries(): [min: number, max: number] {
		if (IsInt32Rule._minValue === undefined
			|| IsInt32Rule._maxValue === undefined
		) {
			IsInt32Rule._minValue = -Math.pow(2, 31);
			IsInt32Rule._maxValue = Math.pow(2, 31) - 1;
		}

		return [
			IsInt32Rule._minValue,
			IsInt32Rule._maxValue
		];
	}
}